import { Accent } from "@tag/tag-components-react-v4";

export const ProjectAccents: Record<string, Accent> = {
    PeoplePlanner: 'teal',
    CareCompliance: 'blue',
    PoliciesAndProcedures: 'purple',
};
